import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '../utils';

/* -------------------------------------------------------------------------------------------------
 * Tooltip / Core
 * -----------------------------------------------------------------------------------------------*/

const UiTooltipProvider = TooltipPrimitive.Provider;

const UiTooltip = TooltipPrimitive.Root;

const UiTooltipTrigger = TooltipPrimitive.Trigger;

const UiTooltipArrow = TooltipPrimitive.Arrow;

const UiTooltipPortal = TooltipPrimitive.Portal;

export interface UiTooltipProps extends React.ComponentProps<typeof UiTooltip> {}

/* -------------------------------------------------------------------------------------------------
 * Tooltip / Content
 * -----------------------------------------------------------------------------------------------*/

const UiTooltipContent = React.forwardRef<HTMLDivElement, TooltipPrimitive.TooltipContentProps>(({ className, sideOffset = 4, ...props }, ref) => (
	<TooltipPrimitive.Content
		ref={ref}
		sideOffset={sideOffset}
		className={cn(
			'z-[211] overflow-hidden rounded-md bg-zinc-900/95 px-3 py-1.5 text-xs text-white',
			'dark:bg-zinc-800/95 dark:text-zinc-50',
			'animate-in fade-in-0 zoom-in-95',
			'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
			'data-[side=bottom]:slide-in-from-top-2',
			'data-[side=left]:slide-in-from-right-2',
			'data-[side=right]:slide-in-from-left-2',
			'data-[side=top]:slide-in-from-bottom-2',
			className,
		)}
		{...props}
	/>
));
UiTooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { UiTooltip, UiTooltipTrigger, UiTooltipContent, UiTooltipProvider, UiTooltipArrow, UiTooltipPortal };
